import React from "react";
import {
  MagnifyingGlassIcon,
  BellIcon,
  EnvelopeIcon,
  UserCircleIcon,
} from "@heroicons/react/24/outline"; // ✅ Heroicons v2 path

const Header = ({ title }) => {
  return (
    <div className="dashboard-header">
      <h1 className="dashboard-header__title">{title}</h1>

      <div className="dashboard-header__actions">
        <div className="dashboard-header__search-container">
          <input
            type="text"
            placeholder="Search..."
            className="dashboard-header__search-input"
          />
          <MagnifyingGlassIcon className="dashboard-header__search-icon" />
        </div>

        <button className="dashboard-header__icon-button">
          <span className="sr-only">View notifications</span>
          <BellIcon aria-hidden="true" />
        </button>
        <button className="dashboard-header__icon-button">
          <span className="sr-only">View messages</span>
          <EnvelopeIcon aria-hidden="true" />
        </button>

        <button className="dashboard-header__profile-button">
          <span className="sr-only">Open user menu</span>
          <UserCircleIcon aria-hidden="true" />
        </button>
      </div>
    </div>
  );
};

export default Header;
